import { ITableCol } from '@data/interfaces/itable.interface'

// Concepto de la factura (espejo del backend invoice.entity `concept`).
export enum INVOICE_CONCEPT_ENUM {
	RENT = 'Renta (mensualidad)',
	FIRST_PAYMENT = 'Pago inicial',
	RESIDUAL = 'Residual',
	MANAGEMENT_EXPENSE = 'Gestoría',
	OTHER = 'Otro',
}
export enum INVOICE_CONCEPT_COLOR_ENUM {
	RENT = 'info',
	FIRST_PAYMENT = 'success',
	RESIDUAL = 'warning',
	MANAGEMENT_EXPENSE = 'secondary',
	OTHER = 'contrast',
}

// Estatus de la factura.
export enum INVOICE_STATUS_ENUM {
	PENDING_FILES = 'Pendiente de archivos',
	LINKED = 'Vigente',
	CANCELLED = 'Cancelada',
	REPLACED = 'Refacturada',
}
export enum INVOICE_STATUS_COLOR_ENUM {
	PENDING_FILES = 'warning',
	LINKED = 'success',
	CANCELLED = 'danger',
	REPLACED = 'secondary',
}

// Método de pago SAT (espejo del backend invoice.entity `paymentType`).
export enum INVOICE_PAYMENT_TYPE_ENUM {
	PUE = 'PUE',
	PPD = 'PPD',
}
export enum INVOICE_PAYMENT_TYPE_COLOR_ENUM {
	PUE = 'secondary',
	PPD = 'info',
}

// Estatus de pago de la factura (conciliación).
export enum INVOICE_PAYMENT_STATUS_ENUM {
	PENDING = 'Pendiente de pago',
	PAID = 'Pagada',
}
export enum INVOICE_PAYMENT_STATUS_COLOR_ENUM {
	PENDING = 'warning',
	PAID = 'success',
}

// Estatus del complemento de pago (REP).
export enum INVOICE_COMPLEMENT_STATUS_ENUM {
	NOT_REQUIRED = 'No requiere',
	PENDING = 'Pendiente',
	RECEIVED = 'Recibido',
}
export enum INVOICE_COMPLEMENT_STATUS_COLOR_ENUM {
	NOT_REQUIRED = 'secondary',
	PENDING = 'warning',
	RECEIVED = 'success',
}

export const INVOICE_CONCEPT_OPTIONS = [
	{ value: 'RENT', label: 'Renta (mensualidad)' },
	{ value: 'FIRST_PAYMENT', label: 'Pago inicial' },
	{ value: 'RESIDUAL', label: 'Residual' },
	{ value: 'MANAGEMENT_EXPENSE', label: 'Gestoría' },
	{ value: 'OTHER', label: 'Otro' },
]
export const INVOICE_PAYMENT_TYPE_OPTIONS = [
	{ value: 'PPD', label: 'PPD' },
	{ value: 'PUE', label: 'PUE' },
]
export const INVOICE_PAYMENT_STATUS_OPTIONS = [
	{ value: 'PAID', label: 'Pagada' },
	{ value: 'PENDING', label: 'Pendiente de pago' },
]
export const INVOICE_COMPLEMENT_STATUS_OPTIONS = [
	{ value: 'PENDING', label: 'Pendiente' },
	{ value: 'RECEIVED', label: 'Recibido' },
	{ value: 'NOT_REQUIRED', label: 'No requiere' },
]
export const INVOICE_STATUS_OPTIONS = [
	{ value: 'LINKED', label: 'Vigente' },
	{ value: 'PENDING_FILES', label: 'Pendiente de archivos' },
	{ value: 'CANCELLED', label: 'Cancelada' },
	{ value: 'REPLACED', label: 'Refacturada' },
]

export const INVOICE_COLUMNS: ITableCol[] = [
	{ type: 'text', field: 'folioFiscal', header: 'Folio Fiscal', showFilter: true }, // Serie+Folio del CFDi (ej. A1198): llave de negocio del flujo de referencias
	{ type: 'text', field: 'uid', header: 'UUID fiscal', showFilter: true }, // UUID real leído del XML (null mientras PENDING_FILES)
	{ type: 'text', field: 'leaseFolio', header: 'Arrendamiento', showFilter: true, dataType: 'link', linkField: 'lease', rootLink: 'lease' }, // folio como texto, navega al detalle del lease (patrón de application/wallet)
	{ type: 'enum', field: 'concept', header: 'Concepto', showFilter: true, dataType: 'enum', enum: INVOICE_CONCEPT_ENUM, enumColor: INVOICE_CONCEPT_COLOR_ENUM, options: INVOICE_CONCEPT_OPTIONS },
	{ type: 'text', field: 'month', header: 'Mes', showFilter: true },
	{ type: 'number', field: 'amount', header: 'Monto', showFilter: true, dataType: 'currency' },
	{ type: 'date', field: 'issueDate', header: 'Fecha CFDI', showFilter: true, dataType: 'date' },
	{ type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: INVOICE_STATUS_ENUM, enumColor: INVOICE_STATUS_COLOR_ENUM, options: INVOICE_STATUS_OPTIONS },
	{ type: 'enum', field: 'paymentType', header: 'Método pago', showFilter: true, dataType: 'enum', enum: INVOICE_PAYMENT_TYPE_ENUM, enumColor: INVOICE_PAYMENT_TYPE_COLOR_ENUM, options: INVOICE_PAYMENT_TYPE_OPTIONS },
	{ type: 'enum', field: 'paymentStatus', header: 'Estatus de pago', showFilter: true, dataType: 'enum', enum: INVOICE_PAYMENT_STATUS_ENUM, enumColor: INVOICE_PAYMENT_STATUS_COLOR_ENUM, options: INVOICE_PAYMENT_STATUS_OPTIONS },
	{ type: 'date', field: 'paidAt', header: 'Fecha de pago', showFilter: true, dataType: 'date' },
	{ type: 'enum', field: 'complementStatus', header: 'Complemento', showFilter: true, dataType: 'enum', enum: INVOICE_COMPLEMENT_STATUS_ENUM, enumColor: INVOICE_COMPLEMENT_STATUS_COLOR_ENUM, options: INVOICE_COMPLEMENT_STATUS_OPTIONS },
]
